export const iconFontAwesomeEmojiFaceGrinSquint = (
	<i className="fa-solid fa-face-grin-squint"></i>
);
